import { useEffect, useState } from 'react'
import QRCode from 'qrcode'

/**
 * Código QR como SVG en línea.
 *
 * Se genera en el navegador con `qrcode` (sin red): la CSP del sitio solo
 * permite recursos propios, así que un servicio externo de QR no cargaría —
 * y tampoco corresponde mandarle a un tercero los códigos de verificación de
 * documentos clínicos.
 */
export function QrCode({ value, size = 96, className = '' }: { value: string; size?: number; className?: string }) {
  const [svg, setSvg] = useState('')

  useEffect(() => {
    let active = true
    QRCode.toString(value, { type: 'svg', margin: 0, errorCorrectionLevel: 'M' })
      .then((markup) => {
        if (active) setSvg(markup)
      })
      .catch(() => {
        if (active) setSvg('')
      })
    return () => {
      active = false
    }
  }, [value])

  if (!svg) return <div style={{ width: size, height: size }} className={className} aria-hidden />
  return (
    <div
      className={className}
      style={{ width: size, height: size }}
      role="img"
      aria-label={`Código QR: ${value}`}
      // El SVG lo produce la propia librería a partir de `value`; no hay HTML de terceros.
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  )
}
